




































































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { AgencySettingsModule } from '@/store/modules/agencySettings';
import UpdateNoteCategoryRequest from '@/models/NoteCategories/UpdateNoteCategoryRequest';
import GiganautVueDialog from '@/components/Shared/GiganautVueDialog';
import ListUtils from '@/lib/listUtils';
import NoteCategoryDto from '@/models/NoteCategories/NoteCategoryDto';
import EmailIntegrationTemplateDto from '@/models/EmailIntegrationTemplates/EmailIntegrationTemplateDto';

@Component({
    name: 'NoteCategoryEdit'
})
export default class extends GiganautVueDialog {
 
  public entity = new NoteCategoryDto();

  @Watch('dialog')
  onDialogChanged(val: boolean, oldVal: boolean) {
    if (val) {
      const noteCategory = JSON.parse(JSON.stringify(AgencySettingsModule.currentNoteCategory));
      this.entity.updatedAt = noteCategory.updatedAt;
      this.entity.name = noteCategory.name;
      this.entity.isEnabledOnWorkerGeneral = noteCategory.isEnabledOnWorkerGeneral;
      this.entity.isEnabledOnWorkerCall = noteCategory.isEnabledOnWorkerCall;
      this.entity.isEnabledOnWorkerMeeting = noteCategory.isEnabledOnWorkerMeeting;
      this.entity.isEnabledOnCompanyGeneral = noteCategory.isEnabledOnCompanyGeneral;
      this.entity.isEnabledOnCompanyCall = noteCategory.isEnabledOnCompanyCall;
      this.entity.isEnabledOnCompanyMeeting = noteCategory.isEnabledOnCompanyMeeting;
      this.entity.isEnabledOnLocationGeneral = noteCategory.isEnabledOnLocationGeneral;
      this.entity.isEnabledOnLocationCall = noteCategory.isEnabledOnLocationCall;
      this.entity.isEnabledOnLocationMeeting = noteCategory.isEnabledOnLocationMeeting;
      this.entity.isEnabledOnContactGeneral = noteCategory.isEnabledOnContactGeneral;
      this.entity.isEnabledOnContactCall = noteCategory.isEnabledOnContactCall;
      this.entity.isEnabledOnContactMeeting = noteCategory.isEnabledOnContactMeeting;
      this.entity.isEnabledOnCampaignGeneral = noteCategory.isEnabledOnCampaignGeneral;
      this.entity.isEnabledOnCampaignCall = noteCategory.isEnabledOnCampaignCall;
      this.entity.isEnabledOnCampaignMeeting = noteCategory.isEnabledOnCampaignMeeting;
      this.entity.isEnabledOnJobGeneral = noteCategory.isEnabledOnJobGeneral;
      this.entity.isEnabledOnJobCall = noteCategory.isEnabledOnJobCall;
      this.entity.isEnabledOnJobMeeting = noteCategory.isEnabledOnJobMeeting;
      this.entity.isEnabledOnBookingGeneral = noteCategory.isEnabledOnBookingGeneral;
      this.entity.isEnabledOnBookingCall = noteCategory.isEnabledOnBookingCall;
      this.entity.isEnabledOnBookingMeeting = noteCategory.isEnabledOnBookingMeeting;

     }
  }

  get loading() {
    return AgencySettingsModule.loadingDialog;
  }

  async save() {
    if (!(this.$refs.form as any).validate()) {
      return;
    }
    const request = new UpdateNoteCategoryRequest();
    request.updatedAt = this.entity.updatedAt;
    request.name = this.entity.name;
    request.isEnabledOnWorkerGeneral = this.entity.isEnabledOnWorkerGeneral;
    request.isEnabledOnWorkerCall = this.entity.isEnabledOnWorkerCall;
    request.isEnabledOnWorkerMeeting = this.entity.isEnabledOnWorkerMeeting;
    request.isEnabledOnCompanyGeneral = this.entity.isEnabledOnCompanyGeneral;
    request.isEnabledOnCompanyCall = this.entity.isEnabledOnCompanyCall;
    request.isEnabledOnCompanyMeeting = this.entity.isEnabledOnCompanyMeeting;
    request.isEnabledOnLocationGeneral = this.entity.isEnabledOnLocationGeneral;
    request.isEnabledOnLocationCall = this.entity.isEnabledOnLocationCall;
    request.isEnabledOnLocationMeeting = this.entity.isEnabledOnLocationMeeting;
    request.isEnabledOnContactGeneral = this.entity.isEnabledOnContactGeneral;
    request.isEnabledOnContactCall = this.entity.isEnabledOnContactCall;
    request.isEnabledOnContactMeeting = this.entity.isEnabledOnContactMeeting;
    request.isEnabledOnCampaignGeneral = this.entity.isEnabledOnCampaignGeneral;
    request.isEnabledOnCampaignCall = this.entity.isEnabledOnCampaignCall;
    request.isEnabledOnCampaignMeeting = this.entity.isEnabledOnCampaignMeeting;
    request.isEnabledOnJobGeneral = this.entity.isEnabledOnJobGeneral;
    request.isEnabledOnJobCall = this.entity.isEnabledOnJobCall;
    request.isEnabledOnJobMeeting = this.entity.isEnabledOnJobMeeting;
    request.isEnabledOnBookingGeneral = this.entity.isEnabledOnBookingGeneral;
    request.isEnabledOnBookingCall = this.entity.isEnabledOnBookingCall;
    request.isEnabledOnBookingMeeting = this.entity.isEnabledOnBookingMeeting;

    await AgencySettingsModule.editNoteCategory(request)
    this.dialog = false;
  }
}
